// import axios from "axios"
import axios from "../../constants/axios"

import endpoints from "../../constants/endpoints"

export const GET_CONFIG_DATA = async (setConfigData, dispatch) => {
  try {
    const response = await axios.get(
      process.env.GATSBY_BASE_URL + endpoints.CONFIG_DATA_FETCH
    )
    if (response.data) {
      dispatch({
        type: "SET_CONFIG",
        payload: response.data,
      })
    }
  } catch (error) {
    if (error && error.response && error.response.status === 401) {
      dispatch({
        type: "LOGIN_ERROR",
        payload: "Session expired, please login again",
      })
      dispatch({
        type: "LOGOUT",
      })
    }
  }
}
